import React from 'react';
import { FieldValues } from 'react-hook-form';

import { InputMode } from 'components/Inputs/Input/constants';
import { InputNumber } from 'components/Inputs/Input';
import { QuestionSize } from '../constants';
import { QuestionNumberProps } from '../types';
import QuestionTemplate from '.';

function QuestionNumber<T extends FieldValues>({
  disabled,
  children,
  control,
  id,
  label,
  name,
  readOnly,
  setValue,
  size = QuestionSize.MEDIUM,
  ...props
}: QuestionNumberProps<T>) {
  return (
    <QuestionTemplate<T>
      control={control}
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      readOnly={readOnly}
      size={size}>
      {({ invalid, onBlur, onChange, ref, value }) => (
        <InputNumber
          disabled={disabled}
          id={id}
          inputRef={ref}
          inputMode={InputMode.NUMERIC}
          invalid={invalid}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          readOnly={readOnly}
          setValue={setValue}
          size={size}
          value={value as string}
          {...props}>
          {children}
        </InputNumber>
      )}
    </QuestionTemplate>
  );
}

export default React.memo(QuestionNumber) as typeof QuestionNumber;
